import React from 'react'
import { useSelector } from 'react-redux'

import { EuiFlexGroup, EuiFlexItem, EuiTitle, EuiButton, EuiPageHeaderSection, EuiPageHeader } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { useWhiteLabel } from 'whiteLabel/WhiteLabelContext'

interface CampaignReportHeaderProps {
  accountName?: string
  onBackClick: () => void
}

const CampaignReportHeader: React.FC<CampaignReportHeaderProps> = ({ accountName, onBackClick }) => {
  const whiteLabel = useWhiteLabel()
  const { currentAccount } = useSelector((state: RootState) => state.app)

  return (
    <EuiPageHeader>
      <EuiPageHeaderSection>
        <EuiTitle>
          <h1>Reports{whiteLabel?.isAgencies() && `: ${currentAccount?.name}`}</h1>
        </EuiTitle>
      </EuiPageHeaderSection>
      <EuiPageHeaderSection>
        <EuiButton color='primary' fill onClick={onBackClick} iconType='arrowLeft'>
          Back to Reports Home
        </EuiButton>
      </EuiPageHeaderSection>
    </EuiPageHeader>
  )
}

export default CampaignReportHeader
